import { TableConfig } from "../../../../common/tables/config/TableConfig";
import { CostPayoutModifierTableRow } from "../../../../../../common/tables/cost-payout-modifier/CostPayoutModifierTableRow";
import { SortOrder } from "../../../../../../common/query-filters";
import { CellType } from "../../../../common/tables/config/CellType";

export const DefaultCPMTableConfig: TableConfig<CostPayoutModifierTableRow> = {
    columns: [
        {
            columnName: "id",
            displayName: "Cost Payout Modifier ID",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "200px",
            sortable: false,
            filterable: false
        },
        {
            columnName: "name",
            displayName: "Name",
            cellType: CellType.textInputWithMenuButton,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "220px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "conditionCountryCode",
            displayName: "Country Code",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "conditionEmailDomains",
            displayName: "Email Domains",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "200px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "conditionIsBundle",
            displayName: "Is Bundle",
            cellType: CellType.checkbox,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "100px",
            sortable: false,
            filterable: false,
            textAlign: "center",
        },
        {
            columnName: "conditionSourceName",
            displayName: "Source Name",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "160px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "conditionFulfillmentService",
            displayName: "Fulfillment Service",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "160px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "priority",
            displayName: "Priority",
            cellType: CellType.numberInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "100px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "createdAt",
            displayName: "Created At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "updatedAt",
            displayName: "Updated At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.DESCENDING,
        sortColumn: "createdAt",
        pageSize: 10,
    },
};
